import { capitalizeFirstLetter } from '@/utils/text-utils';
import { IconButton } from '@destination/components';
import DropdownIcon from '@icons/down_16.svg?react';
import { ReactNode, useState } from 'react';

export interface IModelAttributeCard {
  title: string | ReactNode;
  children?: React.ReactNode;
  variant?: 'DARK' | 'NORMAL' | 'LIGHT';
  defaultOpen?: boolean;
}

const cardOpacities = {
  DARK: 200,
  NORMAL: 100,
  LIGHT: 50
};

export default function ModelAttributeCard({
  title,
  children,
  variant = 'DARK',
  defaultOpen
}: IModelAttributeCard) {
  const [isExpanded, setIsExpanded] = useState(Boolean(defaultOpen));

  return (
    <div className={'ml-5 mb-2'}>
      <div
        className={`${isExpanded ? 'tw-rounded-t-md' : 'tw-rounded-md'} ${
          children && 'hover:tw-cursor-pointer'
        } bg-slate-${
          cardOpacities[variant]
        } tw-bg-white tw-p-4 tw-shadow-[0_4px_20px_0_rgba(0,0,0,0.1)] tw-flex tw-items-center tw-justify-between  p-2 pl-3`}
        onClick={() => children && setIsExpanded(prevExpanded => !prevExpanded)}
      >
        {typeof title === 'string' ? (
          <h3
            className={`tw-text-base ${variant == 'DARK' && 'tw-font-bold'} `}
          >
            {capitalizeFirstLetter(title.replace('_', ' '))}
          </h3>
        ) : (
          title
        )}
        {children && (
          <div className="tw-ml-4">
            <IconButton
              data-testid="dropdown-btn"
              className={isExpanded ? 'rotate-180' : ''}
            >
              <DropdownIcon />
            </IconButton>
          </div>
        )}
      </div>
      {isExpanded && children && (
        <div
          className={`w-full rounded-b-md p-3 bg-slate-${cardOpacities[variant]}`}
        >
          {children}
        </div>
      )}
    </div>
  );
}
